/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Company } from '../models';
// @ts-ignore
import { Person } from '../models';
/**
 * DamageassessorscompanyApi - axios parameter creator
 * @export
 */
export const DamageassessorscompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all damage assessors companies
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyGet: async (trashed?: number, offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/damageassessorscompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (trashed !== undefined) {
                localVarQueryParameter['trashed'] = trashed;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific damage assessor company
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorscompanyIdGet', 'id', id)
            const localVarPath = `/damageassessorscompany/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific damageassessorscompany
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyIdPut: async (id: number, company?: Company, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageassessorscompanyIdPut', 'id', id)
            const localVarPath = `/damageassessorscompany/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new damage assessor company
         * @param {Person} person 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyPost: async (person: Person, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'person' is not null or undefined
            assertParamExists('damageassessorscompanyPost', 'person', person)
            const localVarPath = `/damageassessorscompany`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(person, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DamageassessorscompanyApi - functional programming interface
 * @export
 */
export const DamageassessorscompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DamageassessorscompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all damage assessors companies
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorscompanyGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorscompanyGet(trashed, offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a specific damage assessor company
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorscompanyIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorscompanyIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific damageassessorscompany
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorscompanyIdPut(id: number, company?: Company, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorscompanyIdPut(id, company, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new damage assessor company
         * @param {Person} person 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageassessorscompanyPost(person: Person, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageassessorscompanyPost(person, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DamageassessorscompanyApi - factory interface
 * @export
 */
export const DamageassessorscompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DamageassessorscompanyApiFp(configuration)
    return {
        /**
         * Get all damage assessors companies
         * @param {number} [trashed] Get trashed items.
         * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyGet(trashed?: number, offset?: number, size?: number, options?: any): AxiosPromise<Person> {
            return localVarFp.damageassessorscompanyGet(trashed, offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific damage assessor company
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyIdGet(id: number, options?: any): AxiosPromise<Person> {
            return localVarFp.damageassessorscompanyIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific damageassessorscompany
         * @param {number} id 
         * @param {Company} [company] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyIdPut(id: number, company?: Company, options?: any): AxiosPromise<Company> {
            return localVarFp.damageassessorscompanyIdPut(id, company, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new damage assessor company
         * @param {Person} person 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageassessorscompanyPost(person: Person, options?: any): AxiosPromise<void> {
            return localVarFp.damageassessorscompanyPost(person, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DamageassessorscompanyApi - object-oriented interface
 * @export
 * @class DamageassessorscompanyApi
 * @extends {BaseAPI}
 */
export class DamageassessorscompanyApi extends BaseAPI {
    /**
     * Get all damage assessors companies
     * @param {number} [trashed] Get trashed items.
     * @param {number} [offset] How many items should be skipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorscompanyApi
     */
    public damageassessorscompanyGet(trashed?: number, offset?: number, size?: number, options?: AxiosRequestConfig) {
        return DamageassessorscompanyApiFp(this.configuration).damageassessorscompanyGet(trashed, offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific damage assessor company
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorscompanyApi
     */
    public damageassessorscompanyIdGet(id: number, options?: AxiosRequestConfig) {
        return DamageassessorscompanyApiFp(this.configuration).damageassessorscompanyIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific damageassessorscompany
     * @param {number} id 
     * @param {Company} [company] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorscompanyApi
     */
    public damageassessorscompanyIdPut(id: number, company?: Company, options?: AxiosRequestConfig) {
        return DamageassessorscompanyApiFp(this.configuration).damageassessorscompanyIdPut(id, company, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new damage assessor company
     * @param {Person} person 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DamageassessorscompanyApi
     */
    public damageassessorscompanyPost(person: Person, options?: AxiosRequestConfig) {
        return DamageassessorscompanyApiFp(this.configuration).damageassessorscompanyPost(person, options).then((request) => request(this.axios, this.basePath));
    }
}
